
























import { Component, Prop } from "vue-property-decorator";

// Types
import { IMenuRoute } from "@/models/routes";
import OverviewMixin from "@/mixins/admin/overviewMixin";

@Component({
  components: {
    "provision-requests-listing": () =>
      import("@/components/app/admin/provisioning/provisionRequestsListing.vue")
  }
})
export default class AdminLogsProvisionRequestsView extends OverviewMixin {
  // Props
  @Prop({ default: [] })
  public routes!: IMenuRoute[];

  // Data

  public get tableId(): string {
    return "PRLP1" /** [P]rovision [R]equests [L]ist [P]rovider */;
  }
}
